import React, { useState } from 'react';
import { Button, Space, Tabs } from 'antd';
import EtimsInvoiceList from './EtimsInvoiceList';
import MpesaTransactionList from './MpesaTransactionList';
import PaymentSettingsForm from './PaymentSettingsForm';
import EtimsInvoiceModal from './EtimsInvoiceModal';
import MpesaPaymentModal from './MpesaPaymentModal';

export const BillingPage = ({ farmId }) => {
    const [mpesaModalOpen, setMpesaModalOpen] = useState(false);
    const [etimsModalOpen, setEtimsModalOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRefresh = () => setRefreshKey((k) => k + 1);

    return (
        <>
            <Tabs
                items={[
                    {
                        key: 'payments',
                        label: 'M-Pesa Payments',
                        children: (
                            <>
                                <Space style={{ marginBottom: 16 }}>
                                    <Button type="primary" onClick={() => setMpesaModalOpen(true)}>
                                        Collect M-Pesa Payment
                                    </Button>
                                </Space>
                                <MpesaTransactionList farmId={farmId} refreshKey={refreshKey} />
                            </>
                        )
                    },
                    {
                        key: 'invoices',
                        label: 'eTIMS Invoices',
                        children: (
                            <>
                                <Space style={{ marginBottom: 16 }}>
                                    <Button onClick={() => setEtimsModalOpen(true)}>
                                        Generate eTIMS Invoice Manually
                                    </Button>
                                </Space>
                                <EtimsInvoiceList farmId={farmId} refreshKey={refreshKey} />
                            </>
                        )
                    },
                    {
                        key: 'settings',
                        label: 'Payment Settings',
                        children: <PaymentSettingsForm farmId={farmId} />
                    }
                ]}
            />

            <MpesaPaymentModal
                open={mpesaModalOpen}
                onClose={() => setMpesaModalOpen(false)}
                farmId={farmId}
                onSuccess={handleRefresh}
            />

            <EtimsInvoiceModal
                open={etimsModalOpen}
                onClose={() => setEtimsModalOpen(false)}
                farmId={farmId}
                onSuccess={handleRefresh}
            />
        </>
    );
};